import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBank2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBank2"><Path d="M22 21H2V20H22V21Z" fill="currentColor"/><Path d="M3.5 20.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 20.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 7L12 2.5L21.5 7V10.5H2.5V7Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 20.5V13" stroke="currentColor"/><Path d="M14.5 20.5V13" stroke="currentColor"/><Circle cx="12" cy="7" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconBank2;
